import { User } from '../../shared/types/generated';
import { RBACSchema } from './rbac-permissions';
import { RBACPermissions } from './rbac-types';

export const checkUserRole = (
  user: User | undefined | null,
  permission: RBACPermissions,
): boolean => {
  const roles = user?.roles_on_users?.map((role) => role?.role?.name);

  return !!RBACSchema.find(
    (schema) => roles?.includes(schema.Role) && schema.Permissions.includes(permission),
  );
};
